module.exports = __webpack_public_path__ + "img/ice-cream.1e6ac5c5.svg";